var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { mockData as chatData } from '@web/lib/demo/data/chatEvents';
import { filterData, getOrgUnits, getUserOrgUnits, getUsers } from '@web/lib/demo/utils';
import { ChatEventActionEnum } from '@workalizer/shared';
import { analyticChatActivity } from '@workalizer/shared/services/analyticChatActivity';
import { transformToGroupedChartResponse } from '@workalizer/shared/utils';
export var chatActivity = function (input) {
    var users = getUsers({
        orgUnitId: input.orgUnitId,
        userId: input.userId
    });
    var data = filterData(chatData, [
        {
            key: 'date',
            value: input.dateFrom,
            operator: 'gt'
        },
        {
            key: 'date',
            value: input.dateTo,
            operator: 'lt'
        },
        {
            key: 'action',
            value: ChatEventActionEnum.CHAT_MESSAGE_POSTED,
            operator: 'eq'
        },
        {
            key: 'userId',
            value: users.map(function (user) { return user.id; }),
            operator: 'in'
        }
    ]);
    var events = data.map(function (item) { return ({
        date: new Date(item.date),
        userId: item.userId,
        _count: {
            id: 1
        }
    }); });
    var allUserOrgUnits = getUserOrgUnits();
    var usersInOrgUnits = allUserOrgUnits
        .filter(function (ou) { return users.some(function (u) { return u.id === ou.userId; }); })
        .map(function (ou) { return ({ userId: ou.userId, orgUnitId: ou.orgUnitId }); });
    var result = analyticChatActivity(events, users.map(function (user) { return (__assign(__assign({}, user), { createdAt: new Date(user.createdAt), updatedAt: new Date(user.updatedAt), creationDate: new Date(user.creationDate), role: user.role })); }), new Date(input.dateFrom), new Date(input.dateTo), input.groupBy, usersInOrgUnits);
    var userData = result.map(function (item) { return ({
        date: item.date,
        users: item.users.map(function (u) { return ({
            userId: u.userId,
            orgUnitId: u.orgUnitId,
            value: u.eventsCount
        }); })
    }); });
    var usersForTransform = users.map(function (u) { return ({
        id: u.id,
        name: u.name,
        email: u.email
    }); });
    if (input.orgUnitId === null) {
        var orgUnits = getOrgUnits({});
        return transformToGroupedChartResponse(userData, 'orgUnit', orgUnits.map(function (ou) { return ({ id: ou.id, title: ou.title }); }), usersForTransform, usersInOrgUnits);
    }
    return transformToGroupedChartResponse(userData, 'user', [], usersForTransform, usersInOrgUnits);
};
